import React from 'react';
import { Paper } from '@mui/material';
import { connect } from 'react-redux';
import PasswordForm from '#component/user/form/password';
import { createUserPassword } from '#action/user/settings';
import { whitelabel } from '#config/whitelabel';
import propTypes from './prop-types';
import { CompanyImgCnt, CompanyImgLogo, StyledRoot } from './styles';
import { setDocumentTitle } from '#helper';

class AddUserForm extends React.Component {
  componentDidMount() {
    setDocumentTitle('Create password');
  }

  handleFormSubmit = values => {
    const { password } = values;
    const { match } = this.props;

    return this.props.createUserPassword(
      {
        token: match.params.token,
        password
      },
      () => {
        // this.props.dispatch(reset('UserForm'));
      }
    );
  };

  render() {
    const { classes, ...rest } = this.props;
    return (
      <StyledRoot>
        <Paper>
          <CompanyImgCnt>
            <CompanyImgLogo
              src={whitelabel.buildAssetUrl('media/logo.svg')}
              alt="logo"
            />
          </CompanyImgCnt>
          <PasswordForm
            title="Set your password"
            {...rest}
            handleFormSubmit={this.handleFormSubmit}
            editable={true}
            expanded={true}
            hideCancelButton={true}
          />
        </Paper>
      </StyledRoot>
    );
  }
}

AddUserForm.propTypes = propTypes;

function mapDispatchToProps(dispatch) {
  return {
    createUserPassword(data, callback) {
      return dispatch(createUserPassword(data, callback));
    },
    dispatch
  };
}

export default connect(
  null,
  mapDispatchToProps
)(AddUserForm);
